import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { FormControl, FormGroup, FormLabel, IconButton, MenuItem, Select, Stack } from "@mui/material";
import { arrayNotEmpty } from "../utils";

export interface ColumnMultiListProps {
  columns: string[];
  values: string[];
  onChange?: (values: string[]) => void;
}

export const ColumnMultiList = (props: ColumnMultiListProps) => {
  const { columns, values, onChange } = props;

  const getValues = (length: number) => {
    const items: string[] = [];
    if (arrayNotEmpty(values)) {
      for (const value of values!) {
        if (typeof value === "string" && value?.length > 0) {
          items.push(value);
        }
      }
    }
    while (items.length < length) items.push("");
    return items;
  };

  const valueChanged = (index: number, value: string) => {
    const items = getValues(index + 1);
    items[index] = value;
    if (onChange) onChange(items);
  };

  const onDelete = (index: number) => {
    const items = getValues(index);
    items.splice(index, 1);
    if (onChange) onChange(items);
  };

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">Tokens</FormLabel>
      <FormGroup>
        {getValues((values?.length ?? 0) + 1).map((value, index) => (
          <FormControl key={"control-" + index}>
            <Stack spacing={2} direction="row" alignItems="center">
              <Select sx={{ minWidth: 200 }} key={"select-" + index} value={value || ""} onChange={(e) => valueChanged(index, e.target.value)}>
                {columns?.map((column, subIndex) => {
                  return (
                    <MenuItem key={"item-" + index + "-" + subIndex} value={column}>
                      {column}
                    </MenuItem>
                  );
                })}
              </Select>
              <IconButton key={"button-" + index} onClick={() => onDelete(index)}>
                <DeleteOutlineOutlinedIcon />
              </IconButton>
            </Stack>
          </FormControl>
        ))}
      </FormGroup>
    </FormControl>
  );
};
